import { Controller } from '@hotwired/stimulus'

// Tracks affiliate link clicks for public comparison pages
// Sends tracking data to the server before allowing the click through
export default class extends Controller {
  static values = {
    productId: String,
    retailer: String,
    url: String,
    trackUrl: String
  }

  track(_event) {
    // Don't prevent default - let the link work even if tracking fails
    // Use sendBeacon for reliable tracking without blocking navigation
    const data = {
      product_id: this.productIdValue,
      retailer: this.retailerValue,
      clicked_url: this.urlValue
    }

    // Use sendBeacon for fire-and-forget tracking
    // Falls back to fetch if sendBeacon not available
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' })
      navigator.sendBeacon(this.trackUrlValue, blob)
    } else {
      // Fallback for older browsers - use fetch with keepalive
      fetch(this.trackUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify(data),
        keepalive: true
      }).catch(() => {
        // Silently fail - tracking shouldn't block user navigation
      })
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}
